/* Base translations · IFRS financial statements page — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): ifrs. */
export const I18N_BASE_IFRS = {
  en: {
    ifrs: {
      title: "IFRS Statements",
      subtitle: "Income Statement and Balance Sheet from the trial balance", subtitleSrc: "Income Statement and Balance Sheet from the {source}",
      incomeStatement: "Income Statement",
      balanceSheet: "Balance Sheet",
      item: "Item",
      cogs: "Cost of Goods Sold",
      grossProfit: "Gross Profit",
      opex: "Operating Expenses",
      operatingIncome: "Operating Income",
      netIncome: "Net Income",
      assets: "Assets",
      liabilities: "Liabilities",
      equity: "Equity",
      totalAssets: "Total Assets",
      liabPlusEquity: "Total Liabilities + Equity",
      compareTo: "Compared to",
      exportPdf: "Export PDF",
      fsMappingBtn: "FS Mapping",
      exportBlocked: "Export blocked — mapping incomplete",
      publicationPdf: "Publication PDF",
      publicationAuditTrail: "Publication audit trail",
      unknownUser: "(unknown)",
      setFrameworkFirst: "Set a Presentation Framework first.",
      publicationExportedOverride: "Publication PDF exported WITH override — TIE_CHECK_FAILED watermark stamped.",
      publicationExportedOk: "Publication PDF exported and audit-trail row recorded.",
      publicationExportFailed: "Publication PDF export failed",
      pdfExportFailed: "PDF export failed",
      frameworkNotSet: "Presentation Framework not set",
      frameworkNotSetBody: "Choose {ias1Bold} or {ifrs18Bold} to unlock the new Statement of Financial Position and Profit & Loss renderers. Legacy Income Statement / Balance Sheet tabs below continue to work in the meantime — no data is lost.",
      frameworkEditableUntil: "Changeable by the Partner in Engagement Settings at any time. After the first FS generation, a change keeps existing FS versions read-only and marks the FS \"Regenerate needed\" — it never locks.",
      openEngSettings: "Open Engagement Settings",
      frameworkTooltip: "Set at engagement creation; can be changed in Engagement Settings (existing FS versions are kept).",
      regenNeeded: "Regenerate needed — framework changed ({from} → {to}, by {by} on {at}). Existing FS versions are kept read-only; the next generation uses {to}.",
      frameworkLabel: "Presentation Framework:",
      stillUnmapped: " still unmapped",
      netBalancePrefix: " · net balance ",
      excludedNote: "Excluded from every statement below until you assign a Major Category, Mapping and FS Mapping code.",
      fixNow: "Fix now",
      tabs: {
        soce: "Statement of Changes in Equity",
        cf: "Statement of Cash Flows",
        validation: "Validation",
        notes: "Notes",
      },
      placeholders: {
        soce: "Set a Presentation Framework to render the Statement of Changes in Equity.",
        cf: "Set a Presentation Framework to render the Statement of Cash Flows.",
        validation: "Set a Presentation Framework to run the FS validation dashboard.",
        notes: "Set a Presentation Framework to render Notes to the financial statements.",
      },
      openMapping: "Open Mapping",
      accountsExcluded: " excluded — unmapped",
      andMoreShort: " and {n} more",
      sfpLoading: "Loading Statement of Financial Position…",
      sfpTitleSuffix: " — Statement of Financial Position as at {date}",
      balanced: "Balanced",
      notBalanced: "Not balanced",
      sfpGrandTotal: "Total assets vs. Equity + Liabilities",
      totalPrefix: "Total ",
      plLoading: "Loading Profit & Loss…",
      plTitleIfrs18: "Statement of Profit or Loss (IFRS 18 categorised)",
      plTitleIas1: "Statement of Profit or Loss (IAS 1)",
      plRevenue: "Revenue",
      plGrossProfit: "Gross profit",
      plOtherOpIncome: "Other operating income",
      plOperatingProfit: "Operating profit",
      plBeforeFinTax: "Profit before financing & income tax",
      plBeforeTax: "Profit before income tax",
      plProfitForPeriod: "Profit for the period",
      loadFailedSfp: "Failed to load SFP",
      loadFailedPl: "Failed to load P&L",
      publicationBlocked: "Publication blocked — {n} tie-check(s) failing. Fix them on the Validation tab (or ask a Platform Admin to override).",
      tieCheckFailedHeader: "TIE-CHECK FAILED — Publication PDF is blocked.",
      tieCheckSummary: "{passed}/{total} checks passed.",
      tieCheckFailedList: "Failed checks:",
      tieCheckOverridePrompt: "As Platform Admin you may override. The PDF will carry a TIE_CHECK_FAILED watermark and the failure will be recorded on the audit trail. Proceed?",
      tieCheckMoreLine: "• +{n} more…",
      noteEditorial: {
        header: "Editorial content",
        unsaved: "Unsaved",
        draftWithAI: "Draft with AI",
        noCodeAiDraft: "No note code available for AI draft.",
        aiDrafted: "AI drafted — review and edit, then click Save.",
        aiDraftFailed: "AI draft failed",
        noCodeSave: "No note code available to save.",
        savedToast: "Editorial content saved.",
        aiUnedited: "AI draft (unedited)",
        aiEdited: "AI draft (edited)",
        savedTag: "Saved",
        placeholderDraft: "Draft the editorial paragraph for this note, or click 'Draft with AI' to start.",
        placeholderCommentary: "Add auditor commentary for this note (optional).",
      },
      movement: {
        title: "Movement schedule",
        formula: "Opening + additions − disposals − charge = Closing",
        savedFor: "Movements saved for {segCode}",
        cols: {
          segment: "Segment",
          opening: "Opening",
          additions: "+ Additions",
          disposals: "− Disposals",
          charge: "− Charge",
          closing: "Closing",
          unexplained: "Unexplained",
        },
      },
      soce: {
        loading: "Loading Statement of Changes in Equity…",
        titleSuffix: " — Statement of Changes in Equity · FY{fy}",
        movement: "Movement",
        total: "Total",
        auto: "AUTO",
        footnote: "Transfer to statutory reserve = the year's movement on the statutory-reserve accounts in the ledger (or the engagement's policy when the ledger shows none). Dividends read from accounts mapped to note 2106.2-DIV.",
        footnoteTransfer: {
          ledger: "Transfer to statutory reserve: the year's movement on the statutory-reserve accounts in the ledger.",
          policy: "Transfer to statutory reserve: the engagement's policy (the ledger shows no movement).",
          none: "Transfer to statutory reserve: none this year (no ledger movement and no engagement policy).",
        },
        yearPrefix: "FY{fy}: ",
        priorNotAvailable: "No prior-year column: the earlier year's statement of changes in equity needs the balances at the start of that year, and the data for that year has year-end balances only (for example a trial balance).",
        footnoteDividends: {
          tagged: "Dividends declared: the accounts tagged 2106.2-DIV.",
          payable: "Dividends declared: the year's credits to Dividends payable (no account is tagged 2106.2-DIV).",
          none: "Dividends declared: none found (no 2106.2-DIV tag and no credit to Dividends payable this year).",
        },
      },
      da: {
        notTagged: "Depreciation / amortisation NOT tagged — CFO understated",
        partial: "Depreciation / amortisation partially tagged",
        notTaggedBody: "No P&L accounts are tagged to N98.DEP or N98.AMORT, yet AZEX has detected accounts whose name suggests depreciation or amortisation. The indirect-method add-back reads only from those two sub-notes, so the current Cash Flow understates operating cash by the D&A charge.",
        partialBody: "Some depreciation / amortisation accounts are correctly tagged (N98.DEP / N98.AMORT), but AZEX has detected other name-matching accounts that are not tagged. The CFO add-back is understated by the untagged portion until every P&L D&A row is tagged.",
        needReviewSuffix: " need review — click to jump into FS Mapping:",
        currentlyMapped: " (currently → {mapping})",
        currentlyUntagged: " (currently untagged)",
        andMore: "…and {n} more — open FS Mapping to see all.",
      },
      cf: {
        loading: "Loading Statement of Cash Flows…",
        titleSuffix: " — Statement of Cash Flows (Indirect Method) · FY{fy}",
        cashTie: "Cash tie",
        cashTieBroken: "Cash tie broken · residual {n}",
        reUnexplained: "Retained earnings decreased by {x} with no dividend account mapped. If this is a dividend, map the account to 2106.2-DIV in FS mapping.",
        reUnexplainedUnmapped: "Retained earnings decreased by {x} against account {acct}, which has no FS mapping. {advice}",
        reUnmappedAdviceDiv: "Map it to Dividends payable (FS 3209, note 3209.1-MVMT) and the dividend is found.",
        reUnmappedAdviceOther: "Map it to the FS line it belongs to.",
        // Batch 31 · item 20 (M58)
        interestAssumed: "Interest received is the year's interest income, assumed received in cash. The chart of accounts has an interest receivable ({accts}): interest earned but not yet received is not cash — check the receivable's movement.",
        opSection: "Cash flows from operating activities",
        opBeforeWc: "Operating cash before working capital",
        cashFromOps: "Cash generated from operations",
        taxPaid: "Income tax paid",
        netOp: "Net cash from operating activities",
        invSection: "Cash flows from investing activities",
        netInv: "Net cash used in investing activities",
        finSection: "Cash flows from financing activities",
        netFin: "Net cash from financing activities",
        netChange: "Net change in cash and cash equivalents",
        cashOpening: "Cash and cash equivalents — opening",
        cashClosing: "Cash and cash equivalents — closing",
        colYear: "FY{fy}",
        priorNotAvailable: "No prior-year column: the earlier year's cash flow statement needs the balances at the start of that year, and the data for that year has year-end balances only (for example a trial balance)",
        priorTiePrefix: "FY{fy} SFP cash:",
        currentlyTagged: "Currently tagged:",
        cfoAddBackSoFar: "CFO add-back so far:",
        depSuffix: "(dep)",
        amortSuffix: "(amort)",
        sfpCashPrefix: "SFP cash (code {code}):",
        residualPrefix: "residual:",
      },
      validation: {
        loading: "Loading validation dashboard…",
        title: "Financial Statements Validation Dashboard",
        allPassed: "All {total} checks passed",
        partialPassed: "{passed} of {total} checks passed",
        residualTitle: "Residual (should round to 0)",
        footnote: "Residuals should round to zero; failures point to an unmapped account, an unbalanced GL, or a manual override. One tie check is added per rooted note that has data.",
        groups: {
          tb: "Trial Balance",
          sfp: "Statement of Financial Position",
          soce: "Statement of Changes in Equity",
          cf: "Statement of Cash Flows",
          notes: "Notes to the Financial Statements",
        },
      },
      notes: {
        loading: "Loading Notes to the financial statements…",
        titleSuffix: " — Notes to the Financial Statements · FY{fy}",
        summary: "{withData} of {noteCount} notes with data",
        allTie: "All notes tie",
        noData: "no data",
        fixNowTitle: "Fix now → jump to mapping for FS {code}. Residual: {n}",
        constantHint: "Constant note — text-only. Draft with AI to seed the paragraph, then edit freely before saving.",
        crossCuttingHint: "Cross-cutting disclosure — map accounts to segments under this note (e.g. {example}) or seed editorial content above.",
        totalNote: "Total note {n}",
        linkedFs: "linked FS {code}",
        fsLineResidual: "FS line {code} · residual",
        kinds: {
          rooted: "Rooted",
          constant: "Constant",
          cross_cutting: "Cross-cutting",
        },
        cols: {
          segment: "Segment",
          description: "Description",
        },
      },
    },
  },
  ar: {
    ifrs: {
      title: "قوائم IFRS",
      subtitle: "قائمة الدخل والمركز المالي من ميزان المراجعة", subtitleSrc: "قائمة الدخل والميزانية من {source}",
      incomeStatement: "قائمة الدخل",
      balanceSheet: "قائمة المركز المالي",
      item: "البند",
      cogs: "تكلفة البضاعة المباعة",
      grossProfit: "إجمالي الربح",
      opex: "المصروفات التشغيلية",
      operatingIncome: "الدخل التشغيلي",
      netIncome: "صافي الدخل",
      assets: "الأصول",
      liabilities: "الالتزامات",
      equity: "حقوق الملكية",
      totalAssets: "إجمالي الأصول",
      liabPlusEquity: "إجمالي الالتزامات + حقوق الملكية",
      compareTo: "مقارنة بـ",
      exportPdf: "تصدير PDF",
      fsMappingBtn: "تعيين القوائم المالية",
      exportBlocked: "التصدير محظور — التعيين غير مكتمل",
      publicationPdf: "PDF النشر",
      publicationAuditTrail: "سجل مراجعة النشر",
      unknownUser: "(غير معروف)",
      setFrameworkFirst: "حدد إطار العرض أولاً.",
      publicationExportedOverride: "تم تصدير PDF النشر مع تجاوز — تم ختم علامة TIE_CHECK_FAILED.",
      publicationExportedOk: "تم تصدير PDF النشر وتسجيل صف سجل المراجعة.",
      publicationExportFailed: "فشل تصدير PDF النشر",
      pdfExportFailed: "فشل تصدير PDF",
      frameworkNotSet: "لم يتم تحديد إطار العرض",
      frameworkNotSetBody: "اختر {ias1Bold} أو {ifrs18Bold} لتفعيل عارضات قائمة المركز المالي والأرباح والخسائر الجديدة. تبويبات قائمة الدخل / المركز المالي القديمة أدناه تستمر في العمل — لا تُفقَد أي بيانات.",
      frameworkEditableUntil: "يمكن للشريك تغييره في إعدادات المهمة في أي وقت. بعد أول توليد للقوائم المالية، يُبقي التغيير الإصدارات الحالية للقراءة فقط ويضع علامة \"يلزم إعادة التوليد\" — ولا يُقفَل أبدًا.",
      openEngSettings: "فتح إعدادات المهمة",
      frameworkTooltip: "يُحدَّد عند إنشاء المهمة؛ يمكن تغييره في إعدادات المهمة (تُحفَظ نسخ القوائم المالية الحالية).",
      regenNeeded: "يلزم إعادة الإنشاء — تغيّر الإطار ({from} ← {to}، بواسطة {by} في {at}). تُحفَظ النسخ الحالية للقراءة فقط؛ يستخدم الإنشاء التالي {to}.",
      frameworkLabel: "إطار العرض:",
      stillUnmapped: " لا تزال غير معيَّنة",
      netBalancePrefix: " · صافي الرصيد ",
      excludedNote: "مستبعدة من كل قائمة أدناه حتى تُخصِّص لها فئة رئيسية وتعييناً ورمز تعيين للقوائم المالية.",
      fixNow: "أصلح الآن",
      tabs: {
        soce: "قائمة التغيرات في حقوق الملكية",
        cf: "قائمة التدفقات النقدية",
        validation: "التحقق",
        notes: "الإيضاحات",
      },
      placeholders: {
        soce: "حدد إطار العرض لعرض قائمة التغيرات في حقوق الملكية.",
        cf: "حدد إطار العرض لعرض قائمة التدفقات النقدية.",
        validation: "حدد إطار العرض لتشغيل لوحة التحقق من القوائم المالية.",
        notes: "حدد إطار العرض لعرض الإيضاحات على القوائم المالية.",
      },
      openMapping: "فتح التعيين",
      accountsExcluded: " مستبعدة — غير معيَّنة",
      andMoreShort: " و{n} أخرى",
      sfpLoading: "جاري تحميل قائمة المركز المالي…",
      sfpTitleSuffix: " — قائمة المركز المالي كما في {date}",
      balanced: "متوازنة",
      notBalanced: "غير متوازنة",
      sfpGrandTotal: "إجمالي الأصول مقابل حقوق الملكية + الالتزامات",
      totalPrefix: "إجمالي ",
      plLoading: "جاري تحميل الأرباح والخسائر…",
      plTitleIfrs18: "قائمة الأرباح أو الخسائر (IFRS 18 مصنَّفة)",
      plTitleIas1: "قائمة الأرباح أو الخسائر (IAS 1)",
      plRevenue: "الإيرادات",
      plGrossProfit: "إجمالي الربح",
      plOtherOpIncome: "إيرادات تشغيلية أخرى",
      plOperatingProfit: "الربح التشغيلي",
      plBeforeFinTax: "الربح قبل التمويل وضريبة الدخل",
      plBeforeTax: "الربح قبل ضريبة الدخل",
      plProfitForPeriod: "ربح الفترة",
      loadFailedSfp: "تعذر تحميل قائمة المركز المالي",
      loadFailedPl: "تعذر تحميل الأرباح والخسائر",
      publicationBlocked: "النشر محظور — {n} من فحوصات الربط فاشلة. أصلحها في تبويب التحقق (أو اطلب من مسؤول المنصة التجاوز).",
      tieCheckFailedHeader: "فشل فحص الربط — PDF النشر محظور.",
      tieCheckSummary: "{passed}/{total} فحوصات ناجحة.",
      tieCheckFailedList: "الفحوصات الفاشلة:",
      tieCheckOverridePrompt: "بصفتك مسؤول منصة يمكنك التجاوز. سيحمل PDF علامة TIE_CHECK_FAILED وسيتم تسجيل الفشل في سجل المراجعة. متابعة؟",
      tieCheckMoreLine: "• +{n} أخرى…",
      noteEditorial: {
        header: "المحتوى التحريري",
        unsaved: "غير محفوظ",
        draftWithAI: "صياغة بالذكاء الاصطناعي",
        noCodeAiDraft: "لا يوجد رمز إيضاح متاح للصياغة بالذكاء الاصطناعي.",
        aiDrafted: "تمت الصياغة بالذكاء الاصطناعي — راجع وعدّل، ثم انقر حفظ.",
        aiDraftFailed: "فشلت الصياغة بالذكاء الاصطناعي",
        noCodeSave: "لا يوجد رمز إيضاح متاح للحفظ.",
        savedToast: "تم حفظ المحتوى التحريري.",
        aiUnedited: "صياغة ذكاء اصطناعي (غير معدَّلة)",
        aiEdited: "صياغة ذكاء اصطناعي (معدَّلة)",
        savedTag: "محفوظ",
        placeholderDraft: "صُغ الفقرة التحريرية لهذا الإيضاح، أو انقر 'صياغة بالذكاء الاصطناعي' للبدء.",
        placeholderCommentary: "أضف تعليق المدقق لهذا الإيضاح (اختياري).",
      },
      movement: {
        title: "جدول الحركة",
        formula: "الافتتاحية + الإضافات − الاستبعادات − الحمل = الإقفال",
        savedFor: "تم حفظ الحركات لـ {segCode}",
        cols: {
          segment: "الجزء",
          opening: "الافتتاحية",
          additions: "+ الإضافات",
          disposals: "− الاستبعادات",
          charge: "− الحمل",
          closing: "الإقفال",
          unexplained: "غير مُفسَّر",
        },
      },
      soce: {
        loading: "جاري تحميل قائمة التغيرات في حقوق الملكية…",
        titleSuffix: " — قائمة التغيرات في حقوق الملكية · السنة المالية {fy}",
        movement: "الحركة",
        total: "الإجمالي",
        auto: "تلقائي",
        footnote: "تحويل الاحتياطي القانوني محسوب تلقائياً بنسبة 10% من صافي الربح، بحد أقصى 50% من رأس المال المدفوع. توزيعات الأرباح تُقرأ من الحسابات المعينة للإيضاح 2106.2-DIV.",
        footnoteTransfer: {
          ledger: "التحويل إلى الاحتياطي النظامي: حركة السنة على حسابات الاحتياطي النظامي في دفتر الأستاذ.",
          policy: "التحويل إلى الاحتياطي النظامي: سياسة الارتباط (لا توجد حركة في دفتر الأستاذ).",
          none: "التحويل إلى الاحتياطي النظامي: لا يوجد هذه السنة (لا حركة في دفتر الأستاذ ولا سياسة للارتباط).",
        },
        yearPrefix: "السنة المالية {fy}: ",
        priorNotAvailable: "لا يوجد عمود للسنة السابقة: تحتاج قائمة التغيرات في حقوق الملكية للسنة السابقة إلى الأرصدة في بداية تلك السنة، بينما تحتوي بيانات تلك السنة على أرصدة نهاية السنة فقط (مثل ميزان المراجعة).",
        footnoteDividends: {
          tagged: "توزيعات الأرباح المعلنة: الحسابات الموسومة 2106.2-DIV.",
          payable: "توزيعات الأرباح المعلنة: دائن السنة على حساب توزيعات الأرباح المستحقة (لا يوجد حساب موسوم 2106.2-DIV).",
          none: "توزيعات الأرباح المعلنة: لم يُعثر على شيء (لا وسم 2106.2-DIV ولا دائن على توزيعات الأرباح المستحقة هذه السنة).",
        },
      },
      da: {
        notTagged: "الاستهلاك / الإطفاء غير موسوم — التدفق التشغيلي مُقلَّل",
        partial: "الاستهلاك / الإطفاء موسوم جزئياً",
        notTaggedBody: "لا توجد حسابات أرباح/خسائر موسومة إلى N98.DEP أو N98.AMORT، إلا أن AZEX كشف عن حسابات يوحي اسمها بأنها استهلاك أو إطفاء. إعادة الإضافة بالطريقة غير المباشرة تقرأ فقط من هذين الإيضاحين الفرعيين، لذا يقلل التدفق النقدي الحالي النقد التشغيلي بقيمة مصروف الاستهلاك والإطفاء.",
        partialBody: "بعض حسابات الاستهلاك / الإطفاء موسومة بشكل صحيح (N98.DEP / N98.AMORT)، لكن AZEX كشف حسابات أخرى مطابقة بالاسم غير موسومة. إعادة الإضافة للتدفق التشغيلي مُقلَّلة بالجزء غير الموسوم حتى توسم كل صفوف الاستهلاك والإطفاء في الأرباح والخسائر.",
        needReviewSuffix: " تحتاج مراجعة — انقر للانتقال إلى تعيين القوائم المالية:",
        currentlyMapped: " (حالياً ← {mapping})",
        currentlyUntagged: " (غير موسومة حالياً)",
        andMore: "…و{n} أخرى — افتح تعيين القوائم المالية لعرض الجميع.",
      },
      cf: {
        loading: "جاري تحميل قائمة التدفقات النقدية…",
        titleSuffix: " — قائمة التدفقات النقدية (الطريقة غير المباشرة) · السنة المالية {fy}",
        cashTie: "ربط النقد",
        cashTieBroken: "ربط النقد مكسور · متبقٍّ {n}",
        reUnexplained: "انخفضت الأرباح المبقاة بمبلغ {x} دون ربط أي حساب بتوزيعات الأرباح. إذا كان هذا توزيع أرباح، فاربط الحساب بالرمز 2106.2-DIV في ربط القوائم المالية.",
        reUnexplainedUnmapped: "انخفضت الأرباح المبقاة بمبلغ {x} مقابل الحساب {acct}، وهو غير مربوط بأي بند في ربط القوائم المالية. {advice}",
        reUnmappedAdviceDiv: "اربطه بتوزيعات الأرباح المستحقة (البند 3209، الإيضاح 3209.1-MVMT) فتظهر توزيعات الأرباح.",
        reUnmappedAdviceOther: "اربطه بالبند الذي ينتمي إليه في القوائم المالية.",
        // Batch 31 · item 20 (M58)
        interestAssumed: "الفوائد المقبوضة هي إيرادات الفوائد للسنة، على افتراض أنها قُبضت نقداً. يتضمن دليل الحسابات حساب فوائد مستحقة القبض ({accts}): الفوائد المكتسبة التي لم تُقبض بعد ليست نقداً — راجع حركة هذا الحساب.",
        opSection: "التدفقات النقدية من الأنشطة التشغيلية",
        opBeforeWc: "النقد التشغيلي قبل رأس المال العامل",
        cashFromOps: "النقد المولَّد من العمليات",
        taxPaid: "ضريبة الدخل المدفوعة",
        netOp: "صافي النقد من الأنشطة التشغيلية",
        invSection: "التدفقات النقدية من الأنشطة الاستثمارية",
        netInv: "صافي النقد المستخدم في الأنشطة الاستثمارية",
        finSection: "التدفقات النقدية من الأنشطة التمويلية",
        netFin: "صافي النقد من الأنشطة التمويلية",
        netChange: "صافي التغير في النقد وما في حكمه",
        cashOpening: "النقد وما في حكمه — الافتتاحي",
        cashClosing: "النقد وما في حكمه — الإقفال",
        colYear: "السنة المالية {fy}",
        priorNotAvailable: "لا يوجد عمود للسنة السابقة: تحتاج قائمة التدفقات النقدية للسنة السابقة إلى الأرصدة في بداية تلك السنة، بينما تحتوي بيانات تلك السنة على أرصدة نهاية السنة فقط (مثل ميزان المراجعة)",
        priorTiePrefix: "نقد قائمة المركز المالي للسنة المالية {fy}:",
        currentlyTagged: "الموسومة حاليًا:",
        cfoAddBackSoFar: "إعادة إضافة التدفق التشغيلي حتى الآن:",
        depSuffix: "(استهلاك)",
        amortSuffix: "(إطفاء)",
        sfpCashPrefix: "نقد قائمة المركز المالي (الرمز {code}):",
        residualPrefix: "الفرق:",
      },
      validation: {
        loading: "جاري تحميل لوحة التحقق…",
        title: "لوحة التحقق من القوائم المالية",
        allPassed: "نجحت جميع الفحوصات الـ {total}",
        partialPassed: "{passed} من أصل {total} فحوصات ناجحة",
        residualTitle: "المتبقي (يجب أن يقرب إلى 0)",
        footnote: "يجب أن تقرب المتبقيات إلى صفر؛ الفشل يشير إلى حساب غير معيَّن أو أستاذ غير متوازن أو تجاوز يدوي. تُضاف فحص ربط واحد لكل إيضاح جذري يحتوي بيانات.",
        groups: {
          tb: "ميزان المراجعة",
          sfp: "قائمة المركز المالي",
          soce: "قائمة التغيرات في حقوق الملكية",
          cf: "قائمة التدفقات النقدية",
          notes: "الإيضاحات على القوائم المالية",
        },
      },
      notes: {
        loading: "جاري تحميل الإيضاحات على القوائم المالية…",
        titleSuffix: " — الإيضاحات على القوائم المالية · السنة المالية {fy}",
        summary: "{withData} من أصل {noteCount} إيضاحات تحتوي بيانات",
        allTie: "جميع الإيضاحات مربوطة",
        noData: "لا توجد بيانات",
        fixNowTitle: "أصلح الآن ← انتقل إلى تعيين FS {code}. متبقي: {n}",
        constantHint: "إيضاح ثابت — نص فقط. صُغ بالذكاء الاصطناعي لبذر الفقرة، ثم عدّلها بحرية قبل الحفظ.",
        crossCuttingHint: "إفصاح شامل — عيّن الحسابات إلى الأجزاء تحت هذا الإيضاح (مثل {example}) أو ابذر محتوى تحريري أعلاه.",
        totalNote: "إجمالي الإيضاح {n}",
        linkedFs: "FS المرتبط {code}",
        fsLineResidual: "سطر FS {code} · متبقي",
        kinds: {
          rooted: "جذري",
          constant: "ثابت",
          cross_cutting: "شامل",
        },
        cols: {
          segment: "الجزء",
          description: "الوصف",
        },
      },
    },
  },
};

export default I18N_BASE_IFRS;
